import React from 'react';
import { IClientAttributeModel } from '../../../../../../../Types/ClientModelTypes';
import { IUrvalBooleanCondition } from '../../../../../../../Types/UrvalTypes';
import EDCheckbox from '../../../../../../../BaseComponents/Checkboxes/EDCheckbox';
import { Theme } from '@mui/material/styles';

import { withStyles } from 'tss-react/mui';

interface IProps {
  attribute: IClientAttributeModel;
  condition: IUrvalBooleanCondition;
  setCondition: (newCondition: IUrvalBooleanCondition) => void;
  isSmallScreen: boolean;
  disabled: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
});

class BooleanConditionValues extends React.Component<IProps> {
  handleYesChange = () => {
    const { condition, setCondition } = this.props;

    setCondition({
      yes: !condition.yes,
      no: condition.no,
    });
  };

  handleNoChange = () => {
    const { condition, setCondition } = this.props;

    setCondition({
      yes: condition.yes,
      no: !condition.no,
    });
  };

  render() {
    const { condition, classes, disabled } = this.props;

    return (
      <div className={classes.root}>
        <EDCheckbox
          label="Ja"
          checked={condition.yes || false}
          onCheck={this.handleYesChange}
          testId={'Ja'}
          disabled={disabled}
        />
        <EDCheckbox
          label="Nej"
          checked={condition.no || false}
          onCheck={this.handleNoChange}
          testId={'Nej'}
          disabled={disabled}
        />
      </div>
    );
  }
}

export default withStyles(BooleanConditionValues, styles);
